import { ReactElement, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { CompanyInformation } from '@components';
import { iCourtFormValues } from '@services/CourtService';

function CourtStep6(): ReactElement {
  const context = useFormikContext();
  const { values }: { values: iCourtFormValues } = useFormikContext();
  const { TitleMrMrsMsMissOther, PartialFormID } = values;
  useEffect(() => {
    if (PartialFormID) {
      if (!TitleMrMrsMsMissOther) {
        context.setFieldValue('TitleMrMrsMsMissOther', values.FormData.user.title.toUpperCase());
        context.setFieldTouched('TitleMrMrsMsMissOther');
      }
      context.setFieldValue('TitleMrMrsMsMissOther', values.FormData.user.title.toUpperCase());
      context.setFieldValue('GivenNames', values.FormData.user.givenName);
      context.setFieldValue('FamilyName', values.FormData.user.familyName);
      if (values.FormData.user.licence.number) context.setFieldValue('DRIVER_LICENCE', values.FormData.user.licence.number);
      else context.setFieldValue('DRIVER_LICENCE', values.DRIVER_LICENCE);
      if (values.FormData.user.licence.country === '') context.setFieldValue('StatecountryOfIssue', 'Australia');
      else context.setFieldValue('StatecountryOfIssue', values.FormData.user.licence.country);
      context.setFieldValue('LicenceState', values.FormData.user.licence.state);
      if (values.FormData.user.dateOfBirth.day === '' || values.FormData.user.dateOfBirth.month === '' || values.FormData.user.dateOfBirth.year === '') {
        context.setFieldValue('DOB', null);
      } else context.setFieldValue('DOB', new Date(`${values.FormData.user.dateOfBirth.month}/${values.FormData.user.dateOfBirth.day}/${values.FormData.user.dateOfBirth.year}`));
      context.setFieldValue('PositionOfThePersonWithinTheCompany', values.FormData.company.companyPosition.position);
      context.setFieldValue('OtherPosition', values.FormData.company.companyPosition.other);
      context.setFieldValue('HasDifferentCompanyAddress', values.FormData.company.residentialAddress.hasDifferentResidentialAddress.toString());
      context.setFieldValue('CompanyPostalAddress.LineOne', values.FormData.company.residentialAddress.line1);
      context.setFieldValue('CompanyPostalAddress.LineTwo', values.FormData.company.residentialAddress.line2);
      context.setFieldValue('CompanyPostalAddress.Suburb', values.FormData.company.residentialAddress.suburb);
      context.setFieldValue('CompanyPostalAddress.State', values.FormData.company.residentialAddress.state);
      context.setFieldValue('CompanyPostalAddress.Postcode', values.FormData.company.residentialAddress.postcode);
      if (values.FormData.company.residentialAddress.country === '') context.setFieldValue('CompanyPostalAddress.Country', 'Australia');
      else context.setFieldValue('CompanyPostalAddress.Country', values.FormData.company.postalAddress.country);
      context.setFieldValue('CourtContactNumber.ContactNumber', values.FormData.user.primaryContact.number);
      context.setFieldValue('CourtContactNumber.NumberType', values.FormData.user.primaryContact.type);
      context.setFieldValue('CourtContactNumber.SecondaryContactNumber', values.FormData.user.secondaryContact.number);
      context.setFieldValue('CourtContactNumber.SecondaryNumberType', values.FormData.user.secondaryContact.type);
      context.setFieldValue('CompanyName', values.FormData.company.companyName);
      context.setFieldValue('AbnacnType', values.FormData.company.option);
      if (values.FormData.user.email === null) context.setFieldValue('Email', '');
      else context.setFieldValue('Email', values.FormData.user.email);
      context.setFieldValue('EMAIL_TO', values.FormData.sendcopy !== undefined ? `${values.FormData.sendcopy}` : '');
    }
  }, [TitleMrMrsMsMissOther]);

  return (
    <>
      <CompanyInformation />
    </>
  );
}

export default CourtStep6;
